/**
 *
 * Asynchronously loads the ApplicantsFilter component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
